import { z } from "zod";

export const NovosNegociosArquivoSchema = z.object({
    idNovosNegociosArquivo: z.number().int().optional(),
    idNovosNegocios: z.number().int().optional(),
    nome: z.string().optional().nullable(),
    arquivo: z.instanceof(File).nullable(),
    descricao: z.string().optional().nullable(),
    limparArquivo: z.boolean().default(false),

});

export type NovosNegociosArquivoForm = z.infer<typeof NovosNegociosArquivoSchema>;

export const defaultNovosNegociosArquivoForm: Partial<NovosNegociosArquivoForm> = {
    idNovosNegociosArquivo: undefined,
    idNovosNegocios: undefined,
    nome: undefined,
    arquivo: undefined,
    descricao: undefined,

    limparArquivo: false,

};
